<template>
  <div class="page" id="review" v-bind:class="{ 'show-mobile' : $vuetify.breakpoint.smAndDown }">
    <div class="review-body">
      <v-container class="body-inner">
        <v-row class="body-row">
          <v-col cols="12" md="4" class="review-left score-box d-flex flex-column justify-center align-end">
            <div class="title-box">
              <img class="ramhee" src="../assets/smile.png" alt="ramhee" />
              <p class="score"><strong>4.8점</strong>/5점</p>
            </div>
            <div class="rating-box">
              <div class="ref-text">
                <p>(앱스토어, 2020.07.11 기준, Based on 446 Reviews)</p>
              </div>
              <v-row class="rate-row" v-for="rates in [5,4,3,2,1]" v-bind:key="rates">
                <v-col class="left">
                  <font-awesome-icon :icon="['fas', 'star']" v-for="rate in rates" v-bind:key="rate"></font-awesome-icon>
                </v-col>
                <v-col class="right">
                  <div class="bar-container">
                    <div class="stat-bar" v-bind:class="['bar-' + rates, {show: showStatBar}]" ></div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="review-right tmn-box">
            <div class="masonry-box row" v-masonry orgin-left="true" horizontal-order="true" transition-duration="0.3s" resize="true" item-selector=".review-card">
              <v-col class="review-card" cols="6" md="4" ref="reviews" v-masonry-tile v-for="(item, index) in reviews" v-bind:key="item" v-bind:index="index">
                <a href="https://apps.apple.com/kr/app/%EB%8B%A4%EC%9D%B4%EC%96%B4%ED%8A%B8-%ED%94%84%EB%A0%8C%EC%A6%88/id1466899980#see-all/reviews" target="_blank"><img class="review-img" :src="getThumbUrl(index+1)" alt="review" /></a>
              </v-col>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Review",
        props: ['isReviewPageScrolled'],
        watch: {
            isReviewPageScrolled: function (isCurrent) {
                let target = this.$refs.reviews[1];
                if (isCurrent) {
                    this.isShowBg = true;
                    this.showStatBar = true;
                    target.classList.remove('col-6', 'col-md-4');
                    target.classList.add('col-12', 'col-md-8');
                    this.$redrawVueMasonry();
                    setTimeout(()=>{
                        target.classList.remove('col-12', 'col-md-8');
                        target.classList.add('col-6', 'col-md-4');
                        this.$redrawVueMasonry();
                    }, 2000)
                } else {
                    this.isShowBg = false;
                }
            }
        },
        data: function () {
            return {
                reviews: Array(15),
                isShowBg: false,
                showStatBar: false,
            }
        },
        created() {

        },
        mounted () {
            if (typeof this.$redrawVueMasonry === 'function') {
                this.$redrawVueMasonry()
            }
        },
        methods: {
            getThumbUrl(pic) {
                return require('../assets/reviews/'+pic+'.png')
            },
        },
    }
</script>

<style lang="scss" scoped>
  @media only screen and (min-width: 1080px) {
    .container {
      max-width: 1080px !important;
    }
  }

  @import '../variables';
  #review.show-mobile {
    overflow: visible !important;
    height: auto !important;
    padding-top: 3rem !important;
    .review-left {
      height: auto !important;
      margin-bottom: 2rem;
    }
    .review-right {
      height: auto !important;
      max-height: 600px !important;
      padding: 2rem;
    }
    .rating-box {
      margin-bottom: 1rem !important;
      padding: 0 1rem;
      .rate-row {
        .col {
          padding-bottom: 0 !important;
        }
      }
    }
  }
  #review {
    background: $softBlueColor;
    padding: 4rem 0;
    width: 100%;
    height: 100%;
    position: relative;

    /*animate object*/
    .showBg-enter-active {
      animation: fade-in-top .5s;
    }
    .showBg-leave-active {
      animation: fade-in-top .5s reverse;
    }
    .review-body {
      height: 100%;
      .body-inner {
        height: 100%;
      }
      .body-row {
        height: 100%;

        .score-box {
          height: 100%;
          width: 100%;
          padding: 0 1rem;

          .title-box {
            width: 100%;
            margin-bottom: 2rem;
            text-align: center;
            .ramhee {
              display: inline-block;
              width: 120px;
              height: auto;
            }
            .score {
              color: $basicFontColor;
              text-underline-position: under;
              text-align: center;
              font-size: 2em;
              margin: 0;
              font-family: $brandFont;
              display: inline-block;

              strong {
                margin-right: 1rem;
                font-weight: normal;
                font-size: 2em;
                color: white;
              }
            }
          }
          .rating-box {
            display: flex;
            flex-direction: column;
            width: 100%;
            .rate-row {
              .col {
              }
            }
            .left{
              flex: 0.3;
              display: flex;
              justify-content: flex-start;

              svg {
                color: #ffee58;
              }
            }
            .right {
              flex: 0.7;
            }
            .ref-text {
              min-width: 80%;
              text-align: left;
              font-size: 0.8em;
              font-family: $basicFont;
              margin: 0;
              color: $basicFontColor;
            }
          }
        }
        .tmn-box {
          height: 100%;
          width: 100%;
          padding: 0 2rem;
          overflow: hidden;
          position: relative;

          .review-card {
            margin: 0;
            padding: 0 0.5rem 0.5rem 0.5rem;
            .review-img {
              border-radius: 0 16px 16px 16px;
              width: 100%;
              height: auto;
              box-shadow: $basicBoxShadow;
              border: 1px solid transparent;
            }
          }
          .review-card:hover {
            .review-img {
              border: 1px solid #ee4643;
              transition: ease-in-out 0.1s;
            }
          }
        }
      }
    }

    /* The bar container */
    .bar-container {
      width: 100%;
      background-color: $greyBackgroundColor;
      border: 1px solid $basicFontColor;
      text-align: center;
      color: white;
    }

    /* Individual bars */
    .bar-5 {width: 1%; height: 18px; background-color: #ef5350;}
    .bar-4 {width: 1%; height: 18px; background-color: #29b6f6;}
    .bar-3 {width: 1%; height: 18px; background-color: #ffee58;}
    .bar-2 {width: 1%; height: 18px; background-color: #4dd0e1;}
    .bar-1 {width: 1%; height: 18px; background-color: #f0f4c3;}
    .bar-5.show {width: 87%; height: 18px; background-color: #ef5350;}
    .bar-4.show {width: 7%; height: 18px; background-color: #29b6f6;}
    .bar-3.show {width: 2%; height: 18px; background-color: #ffee58;}
    .bar-2.show {width: 1%; height: 18px; background-color: #4dd0e1;}
    .bar-1.show {width: 2%; height: 18px; background-color: #f0f4c3;}
    .stat-bar.show {
      transition: ease-in-out 0.8s;
    }

  }
</style>
